// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3Oy2Y","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1Ss4i"};